import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges, ViewChild, Inject } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from "@angular/forms";
import { I18nService } from "../../shared/services/i18n.service";
import { GeneralSettings } from "../../profile/models/generic.model";
import { Country, Role } from "../../profile/models/masterdata.model";
import { ContextVerbiage, DataWithSupplierCode, DocumentTemplate, Language, Permission, SupplierContact, SupplierContactPropertyValue } from "../../profile/models/supplier.model";
import { validateAllFormFields } from "../../shared/utils/utils";
import { OnboardingDocument } from "../../profile/models/onboarding.model";
import { DocumentsGridComponent } from "../documents/documents-grid/documents-grid.component";
import { isNullOrUndefined } from "util";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ContactFormComponent } from "app/profile/components/people/contacts/contact-grid/contact-form/contact-form.component";
import { combineLatest, Observable } from "rxjs";
import { OnboardingDocumentsService } from "app/profile/services/onboarding-document.service";
import { DecrementLoaderCount, IncrementLoaderCount } from "app/shared/store/actions";
import { Store } from "@ngrx/store";
import { SupplierState } from "app/profile/store/state/supplierstate.state";
import { SupplierDocumentService } from "app/profile/services/supplier-document.service";
import { DocumentType } from 'app/profile/models/onboarding.model';
import { ContactPermissionsModel } from "../contacts/contact-permissions.model";
import { TslCheckboxChange, TslDialog } from "@tesla/ng-tds";
import { OnboardingContactType } from "app/profile/components/onboarding/contacts-wrapper/contact-group.model";
import { OnboardingRequestType } from "app/profile/enums/onboarding-request";
import { MatRadioChange } from "@angular/material/radio";

@Component({
  selector: 'onboarding-contacts',
  templateUrl: './onboarding-contacts.component.html',
  styleUrls: ['./onboarding-contacts.component.scss']
})
export class OnboardingContactsComponent implements OnInit, OnChanges {
  /** Required supplier code to be provided by onboaridng parent component */
  supplierCode: string = '';

  /** Determines if we need to display a tooltip with the emailInfo */
  showEmailInfo: boolean = false;

  /** Determines if we are adding a new contact or editing an exiting one */
  addingNewContact: boolean = true;

  /** Determines if the form will require at least one file to submit the form */
  requiresDocument: boolean = true;

  /** Determines if current contact type is primary or not */
  ismarkedPrimary: boolean = false;

  /** Primary contact document data from document step status */
  requiredDocuments: OnboardingDocument[];
  onboardingRequiredDocument: OnboardingDocument[];
  documentTypes: DocumentType[] = [];


  /** Permissions of the current user for the contacts form */
  contactPermissions: ContactPermissionsModel = {
    firstName: Permission.ReadWrite,
    lastName: Permission.ReadWrite,
    email: Permission.ReadWrite,
    languageCode: Permission.ReadWrite,
    jobTitle: Permission.ReadWrite,
    mobile: Permission.ReadWrite,
    phone: Permission.ReadWrite,
    fax: Permission.ReadWrite,
    contactTypes: Permission.ReadWrite,
    residenceCountry: Permission.ReadWrite,
    skipResidenceCountry: Permission.ReadWrite
  };

  /** Collection of supported languages to populate the language dropdown */
  languages: Language[];

  countries$: Observable<Country[]>;

  ESignAgreementStatus: string = null;
  PCFSignedDate: string = null;

  /** General settings of the application */
  settings: GeneralSettings;

  /** Collection of supported contact types in the application */
  contactTypes: Role[] = [];

  /** Label text of the save button */
  saveBtnLabel: string = 'Save';

  /** Label text of the cancel button */
  cancelBtnLabel: string = 'Cancel';

  /** Determines whether we show or hide the save button */
  hideSaveBtn: boolean = false;

  /** Determines whether to show or hide the cancel button. Defaults to false. */
  hideCancelButton: boolean = false;

  /** Hides the purpose dropdown and set's the types to this */
  defaultContactTypes: string = null;

  /** Disables the email control and sets the value to the value of this property when it's not null/undefinded */
  defaultEmail: string = null;

  /** Sets validation for the email control where the domain of the email must equal this value */
  requiredEmailDomain: string[] = [];

  /** Supplier contact data from the parent component to set the values of the controls in the form */
  supplierContact: SupplierContact = new SupplierContact();

  /** Determines if the controls should be disabled */
  readOnly = false;

  /** Determines onboarding supplier country */
  vendorCountry = '';

  /** Determines if the showIsPrimaryCheckbox controls should be show/hide */
  showIsPrimaryCheckbox = false;

  /** Get the Supplier Onboarding Type **/
  supplierOnboardingRequestType: string = '';
  isReactivationRequest: boolean = false;


  /** Event to trigger when the form is submitted with valid data */
  @Output('tsl-onSave') onSubmitEvent: EventEmitter<{ supplierContact: SupplierContact }> = new EventEmitter<{ supplierContact: SupplierContact }>();

  /** Event to trigger when the current user is primary contact selection changes*/
  @Output('tsl-onPrimaryContactSelectionChange') onPrimaryContactSelectionChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  /** Event to trigger when user submits a form with errors */
  @Output('tsl-onSaveError') onErrorEvent: EventEmitter<{ errorMessage: string }> = new EventEmitter<{ errorMessage: string }>();

  /** Event to trigger when the user clicks the cancel button */
  @Output('tsl-onCancel') onCancelEvent: EventEmitter<void> = new EventEmitter<void>();

  /** Reference to the documents grid in the template */
  @ViewChild('contactDocumentsGrid', { static: false }) documentsGrid: DocumentsGridComponent;

  /** Contact types grouped in Critial and General types for populating the dropdown */
  contactTypeGroups: Array<{ name: string, types: Role[] }> = [];
  documentAdding: boolean = false;
  esignAgreementId: string = null;
  esignAgreementStatus: string = null;
  public readonly emailInfo: string = this.translate.get("You are unable to change critical contacts email. Please contact vendorchanges@tesla.com to inquire about email changes.");
  private readonly PhoneRegex = '^[a-zA-Z\\d_ #()+-]{0,24}$';
  excludedTypesForContactCopy = ['Material Planning', 'My Details'];
  selectedContact: SupplierContact = null;
  contactsTabData: any;
  //  Form controls
  firstNameControl: FormControl;
  lastNameControl: FormControl;
  emailControl: FormControl;
  languageCodeControl: FormControl;
  jobTitleControl: FormControl;
  mobileControl: FormControl;
  phoneControl: FormControl;
  faxControl: FormControl;
  contactTypesControl: FormControl;
  commentsControl: FormControl;
  residenceCountryControl: FormControl;
  skipResidenceCountryControl: FormControl;
  disableDocumentValidations: boolean;
  contextVerbiage: ContextVerbiage;
  savedContacts: SupplierContact[];
  isContactCopied: boolean = false;
  isNotPrimary: boolean = true;
  documentTemplateType: string = '';
  pcfTemplates: DocumentTemplate[] = [];
  //  Contact form group
  contactForm: FormGroup;
  isSidePanelMode: boolean = false;
  hideForm: boolean = false;
  showHelpText: boolean = true;
  originalEmail: string;

  constructor(public dialogRef: MatDialogRef<OnboardingContactsComponent>,
    @Inject(MAT_DIALOG_DATA) public matData: any,
    private onboardingService: OnboardingDocumentsService,
    private store: Store<SupplierState>,
    private documentService: SupplierDocumentService,
    public translate: I18nService,
    private dialog: TslDialog) {
    this.supplierOnboardingRequestType = matData.SupplierOnboardingType;
    if (this.supplierOnboardingRequestType != null && this.supplierOnboardingRequestType != undefined && (this.supplierOnboardingRequestType == OnboardingRequestType.Reactivation || this.supplierOnboardingRequestType == OnboardingRequestType.EntityExtension)) {
      this.isReactivationRequest = true;
      if (this.requiredDocuments != null && this.requiredDocuments != undefined && this.requiredDocuments.length <= 1) {
        if (this.requiredDocuments.find(x => x.DocumentType == "PCF")) {
          this.disableDocumentValidations = !this.requiredDocuments.find(x => x.DocumentType == "PCF").ValidationRequired;
        }
        else {
          this.disableDocumentValidations = this.vendorCountry != "CN";
        }
      }

    }
    else {
      this.isReactivationRequest = false;
    }

    this.supplierCode = matData.supplierCode;
    this.isSidePanelMode = matData.isSidePanelMode;
    matData.contactTypes.subscribe(res => { if (res) { this.contactTypes = res; } });
    this.defaultContactTypes = matData.defaultContactTypes;
    this.defaultEmail = matData.defaultEmailAddress;
    matData.generalSettings?.subscribe(res => { if (res) { this.settings = res; } });
    this.ismarkedPrimary = matData.ismarkedPrimary;
    matData.languages.subscribe(res => { if (res) { this.languages = res; } });

    this.countries$ = matData.countries;
    this.readOnly = matData.readOnly;
    this.requiredDocuments = matData.requiredDocuments;
    this.requiredEmailDomain = matData.requiredEmailDomain;
    this.requiresDocument = matData.requiresDocument;
    this.showIsPrimaryCheckbox = matData.showIsPrimaryCheckbox;
    this.supplierContact = matData.supplierContact;
    this.vendorCountry = matData.vendorCountry;
    this.contextVerbiage = matData.contextVerbiage;
    let savedContactsSet = new Set(matData?.showAllContacts ? matData.savedContacts : matData.savedContacts?.filter(x => !x?.Types?.includes("Material Planning")));
    this.savedContacts = Array.from(savedContactsSet) as SupplierContact[];
    this.isContactCopied = this.defaultContactTypes == 'Primary' ? matData.ismarkedPrimary : false;
    this.isNotPrimary = this.defaultContactTypes != 'Primary'
    this.contactsTabData = matData.contactsTabData;
    this.originalEmail = this.supplierContact?.Email
    this.documentTemplateType = this.requiredDocuments?.find(x => x.DocumentType == 'PCF')?.Mode;
    //  Initialzie form controls. Disable controls that the user does not have read/write acccess
    this.firstNameControl = new FormControl({ value: '', disabled: this.contactPermissions.firstName !== Permission.ReadWrite },
      [Validators.required, Validators.pattern("^([a-zA-Z\\s]+)$")]);

    this.lastNameControl = new FormControl({ value: '', disabled: this.contactPermissions.lastName !== Permission.ReadWrite },
      [Validators.required, Validators.pattern("^([a-zA-Z\\s]+)$")]);

    this.emailControl = new FormControl({ value: '', disabled: this.contactPermissions.email !== Permission.ReadWrite },
      [Validators.required, Validators.email, this.requiredDomainValidator(), this.duplicateEmailValidator()]);

    this.languageCodeControl = new FormControl({ value: '', disabled: this.contactPermissions.languageCode !== Permission.ReadWrite },
      [Validators.required]);

    this.jobTitleControl = new FormControl({ value: '', disabled: this.contactPermissions.jobTitle !== Permission.ReadWrite },
      [Validators.required]);

    this.mobileControl = new FormControl({ value: '', disabled: this.contactPermissions.mobile !== Permission.ReadWrite },
      [Validators.pattern(this.PhoneRegex)]);

    this.phoneControl = new FormControl({ value: '', disabled: this.contactPermissions.phone !== Permission.ReadWrite },
      [Validators.required, Validators.pattern(this.PhoneRegex)]);

    this.faxControl = new FormControl({ value: '', disabled: this.contactPermissions.fax !== Permission.ReadWrite },
      [Validators.pattern(this.PhoneRegex)]);

    this.contactTypesControl = new FormControl({ value: this.defaultContactTypes || '', disabled: this.contactPermissions.contactTypes !== Permission.ReadWrite },
      [Validators.required]);

    this.commentsControl = new FormControl('');

    this.residenceCountryControl  = new FormControl({ value: '', disabled: this.contactPermissions.residenceCountry !== Permission.ReadWrite },
      [Validators.required]);

    this.skipResidenceCountryControl  = new FormControl({ value: '', disabled: this.contactPermissions.skipResidenceCountry !== Permission.ReadWrite });
    this.skipResidenceCountryControl.valueChanges.subscribe(res => {
      if(res) {
        this.residenceCountryControl.setValue(null, { emitEvent: false });
        this.residenceCountryControl.clearValidators();
        this.residenceCountryControl.updateValueAndValidity();
        this.residenceCountryControl.disable();
      } else {
        this.residenceCountryControl.setValidators([Validators.required]);
        this.residenceCountryControl.updateValueAndValidity();
        this.residenceCountryControl.enable();
      }
    })

    //  Initialize form group
    this.contactForm = new FormGroup({
      firstName: this.firstNameControl,
      lastName: this.lastNameControl,
      email: this.emailControl,
      languageCode: this.languageCodeControl,
      jobTitle: this.jobTitleControl,
      mobile: this.mobileControl,
      phone: this.phoneControl,
      fax: this.faxControl,
      types: this.contactTypesControl,
      comments: this.commentsControl,
      residenceCountry: this.residenceCountryControl,
      skipResidenceCountry: this.skipResidenceCountryControl
    });
    if (this.supplierContact?.DocumentInfos?.length >= 1) {
      this.onboardingRequiredDocument = this.supplierContact.DocumentInfos;
      this.onboardingRequiredDocument.forEach(doc => {
        if (doc?.Templates?.length >= 1) {
          doc.Templates = this.requiredDocuments?.find(x => x.DocumentType == doc.DocumentType)?.Templates;
        }
      });
    }
    else {
      this.onboardingRequiredDocument = [this.requiredDocuments?.find(x => x.DocumentType == 'PCF')];
    }

    if (this.defaultContactTypes == 'Primary' && (this.ismarkedPrimary || this.isReactivationRequest)) {
      this.hideForm = true;
    }

    //set selectedcontact for drop down
    this.selectedContact = this.savedContacts?.find(x => x?.Email == this.supplierContact?.Email && x.Types?.includes(this.defaultContactTypes));
    if (this.defaultContactTypes != 'Primary' && !this.excludedTypesForContactCopy.includes(this.defaultContactTypes) && !this.selectedContact) {
      this.hideForm = true;
    }
    if (this.selectedContact && this.readOnly) {
      this.copyContact()
    }

    this.showHelpText = this.defaultContactTypes && this.defaultContactTypes?.toLocaleLowerCase().includes("subtier") ? false : true;
  }

  ngOnInit(): void {
    //  Set the initial values of the contact form
    this.setContactForm();
    if (this.showIsPrimaryCheckbox) {
      if (![true, false].includes(this.ismarkedPrimary)) this.hideForm = true;
      this.store.dispatch(new IncrementLoaderCount());
      var pcfTemplate = this.documentService.getDocumentTemplates("Primary Contact Form");
      var docTypes = this.onboardingService.getDocumentTypes();
      combineLatest([pcfTemplate, docTypes]).subscribe(([pcf, docType]) => {
        this.pcfTemplates = pcf;
        this.documentTypes = docType;
        this.store.dispatch(new DecrementLoaderCount());
      })
    }
    //  Set the initial values of the purpose dropdown
    this.setContactTypeGroups();
  }
  ngOnDestroy(): void {

  }

  isPrimaryChanged(event: MatRadioChange) {
    this.hideForm = false;
    // check vendorcountry
    if (this.vendorCountry == 'CN') {
      // china document always upload
      this.disableDocumentValidations = false;
    }
    else {
      if (event.value) {
        this.disableDocumentValidations = true;
        // switch back to original type
        if (this.requiredDocuments?.length >= 1 && this.documentTemplateType) {
          var pcf = Object.assign({}, this.requiredDocuments?.find(x => x.DocumentType == 'PCF'));
          pcf.Mode = this.documentTemplateType;
          pcf.Templates = [this.pcfTemplates?.find(x => x.templateType.toLowerCase() == this.documentTemplateType.toLowerCase())?.template];
          this.onboardingRequiredDocument = [pcf];
        }
      }
      else {
        this.disableDocumentValidations = true;
        // if pcf is esign, switch to upload and disable validation
        if (this.requiredDocuments?.length >= 1 && this.requiredDocuments?.findIndex(x => x.Mode.toLowerCase() == 'esign') > -1) {
          // switch to upload
          var pcf = Object.assign({}, this.requiredDocuments?.find(x => x.Mode.toLowerCase() == 'esign'));
          pcf.Mode = 'Upload'
          pcf.ESignAgreementId = null
          pcf.ESignAgreementStatus = null
          pcf.Templates = [this.pcfTemplates?.find(x => x.templateType.toLowerCase() == 'upload')?.template];
          this.onboardingRequiredDocument = [pcf]
        }
      }
    }

    if (event.value) {
      this.isContactCopied = true;
      this.supplierContact = this.contactsTabData?.find(ct => ct.type == OnboardingContactType.MYDETAILS)?.contact;
      this.readOnly = true;
      this.ismarkedPrimary = true;
      this.setContactForm();
    }
    else {
      this.hideForm = false;
      this.ismarkedPrimary = false;
      this.isContactCopied = false;
      this.readOnly = true;
      this.clearForm();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    //  Detect changes for when the parent component is passing new data about the contact
    if (changes.supplierContact) {
      this.setContactForm();
    }

    //  We need to detect the changes to contactTypes because we have to update the contactTypeGroups
    //  So the dropdown values of the purpose field can be updated as well.
    if (changes.contactTypes) {
      this.setContactTypeGroups();
    }

    if (changes.readOnly) {
      //  Enable/Disable controls
      //  Required to use setTimeout due to issue when disabling controls in ngInit
      //  See for more: github.com/angular/angular/issues/22556
      setTimeout(() => this.enableControls(), 500);
    }
  }

  /** Sets the controls for the contact form */
  private setContactForm() {
    //  Set values to each control
    this.firstNameControl.setValue(this.supplierContact?.FirstName || '', { emitEvent: false });
    this.lastNameControl.setValue(this.supplierContact?.LastName || '', { emitEvent: false });
    this.emailControl.setValue(this.supplierContact?.Email || '', { emitEvent: false });
    this.languageCodeControl.setValue(this.supplierContact?.LanguageCode || '', { emitEvent: false });
    this.jobTitleControl.setValue(this.supplierContact?.JobTitle || '', { emitEvent: false });
    this.mobileControl.setValue(this.supplierContact?.Mobile || '', { emitEvent: false });
    this.phoneControl.setValue(this.supplierContact?.Phone || '', { emitEvent: false });
    this.faxControl.setValue(this.supplierContact?.Fax || '', { emitEvent: false });
    this.contactTypesControl.setValue(this.defaultContactTypes || this.supplierContact?.Types || '', { emitEvent: false });
    this.commentsControl.setValue(this.supplierContact?.Comment || '', { emitEvent: false });
    this.skipResidenceCountryControl.setValue(this.supplierContact?.SkipResidenceCountry || false, { emitEvent: false });
    if (this.supplierContact?.SkipResidenceCountry) {
      this.residenceCountryControl.setValue(null, { emitEvent: false });
      this.residenceCountryControl.clearValidators();
      this.residenceCountryControl.updateValueAndValidity();
      this.residenceCountryControl.disable();
    } else {
      this.residenceCountryControl.setValue(this.supplierContact?.ResidenceCountry || '', { emitEvent: false });
      this.residenceCountryControl.setValidators([Validators.required]);
      this.residenceCountryControl.updateValueAndValidity();
      this.residenceCountryControl.enable();
    }

    //  Check if we have a default value for email
    if (this.defaultEmail) {
      this.emailControl.setValue(this.defaultEmail, { emitEvent: false });
      this.emailControl.disable({ emitEvent: false });
    }

    if (this.isReactivationRequest == true) {
      if (this.requiredDocuments != null && this.requiredDocuments != undefined && this.requiredDocuments.length <= 1) {
        if (this.requiredDocuments.find(x => x.DocumentType == "PCF")) {
          this.disableDocumentValidations = !this.requiredDocuments.find(x => x.DocumentType == "PCF").ValidationRequired;
        }
        else {
          this.disableDocumentValidations = this.vendorCountry != "CN";;
        }
      }

    }
    else {
      this.disableDocumentValidations = this.vendorCountry != "CN";
    }

    //  Enable/Disable controls
    //  Required to use setTimeout due to issue when disabling controls in ngInit
    //  See for more: github.com/angular/angular/issues/22556
    setTimeout(() => this.enableControls(), 500);
  }

  /** Enables or disables address controls */
  private enableControls() {
    let controls = [
      this.firstNameControl,
      this.lastNameControl,
      this.languageCodeControl,
      this.jobTitleControl,
      this.mobileControl,
      this.phoneControl,
      this.faxControl,
      this.contactTypesControl,
      this.commentsControl,
      this.skipResidenceCountryControl,
      this.residenceCountryControl
    ];

    let criticalControls = [
      this.firstNameControl,
      this.lastNameControl,
      this.emailControl
    ];

    if (!this.defaultEmail) {
      controls.push(this.emailControl);
    }

    if (this.defaultEmail && this.readOnly) {
      controls.push(this.emailControl);
    }

    if (this.readOnly) {
      // for reactivation enable non critical fields to change so that they can fill missing data
      controls.forEach(control => {
        if(this.isReactivationRequest){
          if(criticalControls.includes(control)){
            control.disable({ emitEvent: false })
          }
        }else{
          control.disable({ emitEvent: false })
        }
      });
    } else {
      controls.forEach(control => control.enable({ emitEvent: false }));
    }
  }

  /** Sets the values of the "purpose" dropdown */
  private setContactTypeGroups() {
    if (this.contactTypes) {
      //  Set the contact types groups
      this.contactTypeGroups = [
        { name: this.translate.get('Critical'), types: this.contactTypes?.filter(type => type.isCritical === true).sort((a, b) => a.id.localeCompare(b.id)) },
        { name: this.translate.get('General'), types: this.contactTypes?.filter(type => type.isCritical === false).sort((a, b) => a.id.localeCompare(b.id)) }
      ];
    } else {
      this.contactTypeGroups = [
        { name: this.translate.get('Critical'), types: [] },
        { name: this.translate.get('General'), types: [] }
      ];
    }
  }

  disableContactType(type: any): boolean {

    //  TODO: DETERMINE IF TYPE IS DISABLED AS AN OPTION IN THE CONTACT TYPES DROP DOWN
    return false;
  }


  copyContact() {
    // set form value to selectedContact
    if (this.selectedContact) {
      this.supplierContact = this.selectedContact;
      this.isContactCopied = true;
      this.readOnly = true;
      this.setContactForm();
      this.contactForm.updateValueAndValidity();
    }
  }
  getCategoryTooltip(val): string {
    if (val.toLowerCase() === 'profile admin') {
      return this.translate.get("Supplier Profile Admin has access to add secondary contacts for your organization’s use.")
    }
    else {
      return "";
    }
  }

  /** Event handler for the submit event */
  submit() {
    if (this.contactForm.status == "VALID" || this.contactForm.status == "DISABLED") {
      //  Check if user has provided documents if required
      if (this.requiredDocuments && this.requiredDocuments?.length > 0 && this.disableDocumentValidations === false && this.documentsGrid) {
        this.documentsGrid.isValid().subscribe((val) => {
          if (val === true) {
            this.processSubmit()
          } else {
            this.onErrorEvent.emit({ errorMessage: 'Contact document is missing' });
            return
          }
        });
      }
      else {
        this.processSubmit();
      }

    } else {
      //  Trigger error event
      validateAllFormFields(this.contactForm);
      this.onErrorEvent.emit({ errorMessage: this.translate.get('Contact fields are not completed') });

      if (this.documentsGrid) {
        //  Trigger validation to show error messages
        this.documentsGrid.isValid();
      }
    }
  }

  private processSubmit() {
    let supplierContact = this.getFormData();
    let selectedContactType;
    if (this.isContactCopied) {
      selectedContactType = this.defaultContactTypes == 'Primary' ? 'My Details' : this.contactsTabData?.find(x => x?.contact?.Email == this.selectedContact?.Email && !x.isContactCopied)?.type;
    }
    if (this.isSidePanelMode) this.dialogRef.close([supplierContact, this.isContactCopied, selectedContactType || this.defaultContactTypes, this.isReactivationRequest]);
    else {
      document
        .getElementsByClassName('animate__animated')[0]
        .classList.add('animate__slideOutRight');
      setTimeout(() => {
        this.dialogRef.close([supplierContact, this.isContactCopied, selectedContactType || this.defaultContactTypes, this.isReactivationRequest]);
      }, 1000);
    }
  }

  public getFormData() {
    //  Trigger onSubmit event
    let supplierContact = new SupplierContact();
    supplierContact.FirstName = this.firstNameControl.value.trim();
    supplierContact.LastName = this.lastNameControl.value.trim();
    supplierContact.Email = this.emailControl.value;
    supplierContact.LanguageCode = this.languageCodeControl.value;
    supplierContact.JobTitle = this.jobTitleControl.value;
    supplierContact.Mobile = this.mobileControl.value;
    supplierContact.Phone = this.phoneControl.value;
    supplierContact.Fax = this.faxControl.value;
    supplierContact.Types = [this.contactTypesControl.value];
    supplierContact.Comment = this.commentsControl.value;
    supplierContact.ResidenceCountry = this.residenceCountryControl.value;
    supplierContact.SkipResidenceCountry = this.skipResidenceCountryControl.value;

    //  Append uploaded documents to address object
    let contactDocuments = this.documentsGrid && this.documentsGrid?.documents ? this.documentsGrid?.documents?.map(doc => ({ ...doc, FormGroup: null })) : [];
    supplierContact.DocumentInfos = contactDocuments;
    contactDocuments.forEach(doc => {
      let document = this.documentsGrid.documents?.find(d => d.DocumentID === doc.DocumentID);
      if (document && !isNullOrUndefined(document.FormGroup)) {
        doc.SignedDate = document.FormGroup.get('SignedDate').value;
      }
    })
    supplierContact.Documents = contactDocuments?.map(doc => doc.DocumentID);

    return supplierContact;
  }

  /** Event handler for the click event of the cancel button */
  cancel() {
    //  Trigger event
    // this.onCancelEvent.emit();
    if (this.isSidePanelMode) this.dialogRef.close();
    else {
      document
        .getElementsByClassName('animate__animated')[0]
        .classList.add('animate__slideOutRight');
      setTimeout(() => {
        this.dialogRef.close()
      }, 1000);
    }
  }

  /** Event handler for the click event of the close button */
  close() {
    //  Trigger event
    if (this.isSidePanelMode) this.dialogRef.close();
    else {
      document
        .getElementsByClassName('animate__animated')[0]
        .classList.add('animate__slideOutRight');
      setTimeout(() => {
        this.dialogRef.close();
      }, 1000);
    }
  }

  /** Custom validator for the email control where it checks that the value of the controls ends with the required domain input */
  requiredDomainValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (this.requiredEmailDomain) {
        let email = control.value as string;
        email = email.toLowerCase();
        let domain = email.substring(email.lastIndexOf("@"));
        console.log('Domain Validation',this.requiredEmailDomain, domain);
        var isDomainExists = this.requiredEmailDomain.map(x => x?.toLowerCase()).includes(domain);
        return isDomainExists == false ? { requiredDomain: { value: control.value } } : null;
      }

      //  We ignore validation since there isn't a required domain
      return null;
    };
  }

  /** Custom validator for duplicate email check */
  duplicateEmailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (this.savedContacts?.length) {
        if (this.savedContacts.findIndex(x => x.Email == control.value) > -1) {
          if (control.value != this.originalEmail) return { duplicateEmail: { value: control.value } };
        }
      }
      return null;
    };
  }

  clearForm() {
    this.firstNameControl.setValue('', { emitEvent: false });
    this.lastNameControl.setValue('', { emitEvent: false });
    this.emailControl.setValue('', { emitEvent: false });
    this.languageCodeControl.setValue('', { emitEvent: false });
    this.jobTitleControl.setValue('', { emitEvent: false });
    this.residenceCountryControl.setValue('', { emitEvent: false });
    this.skipResidenceCountryControl.setValue('', { emitEvent: false });
    this.mobileControl.setValue('', { emitEvent: false });
    this.phoneControl.setValue('', { emitEvent: false });
    this.faxControl.setValue('', { emitEvent: false });
    this.contactTypesControl.setValue(this.defaultContactTypes || this.supplierContact?.Types || '', { emitEvent: false });
    this.commentsControl.setValue('', { emitEvent: false });
    this.contactForm.enable();
    this.contactForm.updateValueAndValidity();
    this.isContactCopied = false;
    this.originalEmail = null;
  }

  onAssignContactChange(event) {
    this.hideForm = false;
    if (event?.value?.Email) {
      this.copyContact()
    } else {
      this.clearForm()
    }
  }
}
